<script setup lang="ts"></script>

<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <rect width="24" height="24" fill="url(#pattern0_5017_5)" />
    <defs>
      <pattern
        id="pattern0_5017_5"
        patternUnits="userSpaceOnUse"
        patternTransform="matrix(16.83 0 0 16.83 0 -1.20208)"
        preserveAspectRatio="none"
        viewBox="0 -1.41422 19.8 19.8"
        width="1"
        height="1"
      >
        <use
          xlink:href="#pattern0_5017_5_inner"
          transform="translate(-19.8 -19.8)"
        />
        <use
          xlink:href="#pattern0_5017_5_inner"
          transform="translate(0 -19.8)"
        />
        <use
          xlink:href="#pattern0_5017_5_inner"
          transform="translate(-19.8 0)"
        />
        <g id="pattern0_5017_5_inner">
          <line
            y1="-1"
            x2="28.2843"
            y2="-1"
            transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 25 25)"
            stroke="#FF0000"
            stroke-width="2"
          />
          <line
            y1="-1"
            x2="28.2843"
            y2="-1"
            transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 20 30)"
            stroke="#FF0000"
            stroke-width="2"
          />
          <line
            y1="-1"
            x2="28.2843"
            y2="-1"
            transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 30 20)"
            stroke="#FF0000"
            stroke-width="2"
          />
        </g>
      </pattern>
    </defs>
  </svg>
</template>
